import dayjs from 'dayjs';
import React, { useRef, useState } from 'react';
import CategoryNavigation from '../../components/CategoryNavigation/CategoryNavigation';
import FreeTrialGatedBlock from '../../components/GatedBlock/FreeTrialGatedBlock';
import GatedBlock from '../../components/GatedBlock/GatedBlock';
import { useGlobalContext } from '../../components/GlobalContextProvider/GlobalContextProvider';
import Loader from '../../components/Loader/Loader';
import TagsList from '../../components/TagsList/TagsList';
import { textMonthDateFormat } from '../../consts/date-formats';
import {
  FREE_USER_LEVEL,
  PAID_RESTRICTION_TYPE,
  TRIAL_RESTRICTION_TYPE,
  TRIAL_USER_LEVEL,
} from '../../consts/restrictionTypes';
import useBreadcrumbsNav from '../../hooks/useBreadcrumbsNav';
import useDynamicContentFetch from '../../hooks/useDynamicContentFetch';
import useSendIsContentCroppedToGTM from '../../hooks/useSendIsContentCroppedToGTM';
import {
  EventDate,
  DetailedPageNav,
  InfoRow,
  Story,
  PressNavigation,
} from '../../shared-styled/blocks/detailedPageBlocks';
import { DetailedContentContainer } from '../../shared-styled/layout/DetailedContentContainer';
import { Light } from '../../shared-styled/typography/Bold';
import { DetailPageTitle } from '../../shared-styled/typography/titles';
import styles from '../../styles/print-media.module.css';
import { IS_NEXT_EXPORT } from '../../utils/export';
import BasePageWrap from '../BasePage';

const NewsPage = (props) => {
  const { percentOfCoveredTitle, isLogged, user } = useGlobalContext();
  const [isLoading, setIsLoading] = useState();

  const pageData = useDynamicContentFetch(props, setIsLoading);

  const titleRef = useRef();
  useBreadcrumbsNav(titleRef);

  const freeUserRestriction =
    user &&
    user.userLevel === FREE_USER_LEVEL &&
    (pageData.restrictionType === TRIAL_RESTRICTION_TYPE ||
      pageData.restrictionType === PAID_RESTRICTION_TYPE);
  const trialUserRestriction =
    user &&
    user.userLevel === TRIAL_USER_LEVEL &&
    pageData.restrictionType === PAID_RESTRICTION_TYPE;

  useSendIsContentCroppedToGTM(pageData, pageData.restrictionType, 'news');

  return (
    <DetailedContentContainer>
      <PressNavigation
        $opacity={percentOfCoveredTitle}
        $isVisibleOnPrint={true}
      >
        <CategoryNavigation className={styles.hideForPrint} />
        <DetailedPageNav>
          <DetailPageTitle ref={titleRef}>{pageData.title}</DetailPageTitle>
          <InfoRow>
            {pageData.source && (
              <p>
                <Light>Source:</Light> {pageData.source}
              </p>
            )}
            <EventDate>
              {dayjs(pageData.publishedDate).format(textMonthDateFormat)}
            </EventDate>
          </InfoRow>
          <TagsList tagsList={pageData.countryList} />
        </DetailedPageNav>
      </PressNavigation>

      <Story html={pageData.story} />

      {isLoading && <Loader />}

      {!IS_NEXT_EXPORT && pageData.restricted && (
        <>
          {!isLogged && <GatedBlock isHigher={true} />}

          {isLogged &&
            process.env.NEXT_PUBLIC_LIMITED_FREE_TRIAL_ENABLED === 'True' &&
            (trialUserRestriction || freeUserRestriction) && (
              <FreeTrialGatedBlock
                isHigher={true}
                recordName={pageData.title}
              />
            )}
        </>
      )}
    </DetailedContentContainer>
  );
};

// props: {
//   title,
//   story,
//   publishedDate,
//   source,
//   countryList,
//   restricted,
// }

export default BasePageWrap(NewsPage);
